import './entypo/entypo-svg.tag'
import './station-infobox/station-infobox.tag'
import './searchbox/searchbox.tag'
import './city-infobox/city-infobox.tag'
import './bullet-bar/bullet-bar.tag'
import './legend/legend.tag'
import data from '../data/datasets.js'

riot.tag2('control-button', '<button class="btn controls__btn" onclick="{action}" disabled="{opts.disabled}"> <entypo-svg symbol="{opts.action}"></entypo-svg> </button>', '', '', function(opts) {

  this.action = this.parent.parent[this.opts.action]
});

riot.tag2('control-buttons', '<control-button action="info"></control-button> <control-button action="reverse"></control-button> <control-button action="goTop" disabled="{parent.start === 0}"></control-button> <control-button action="goBack" disabled="{parent.start === 0}"></control-button> <control-button action="goForth" disabled="{parent.end === parent.length}"></control-button> <control-button action="goBottom" disabled="{parent.end === parent.length}"></control-button>', '', 'class="controls"', function(opts) {
});

riot.tag2('measurement-viz', '<section class="measurement-viz__section--info"> <station-infobox></station-infobox> <city-infobox></city-infobox> </section> <section class="measurement-viz__section--viz"> <searchbox></searchbox> <viz-legend></viz-legend> <control-buttons></control-buttons> <section class="bullet-bars"> <bullet-bar each="{city in cities}" data="{city}" measurements="{city.measurements}"></bullet-bar> </section> <control-buttons></control-buttons> </section>', '', 'class="measurement-viz__wrapper"', function(opts) {

  this.reversed = false
  this.cities = data.slice(0, 10)
  this.start = 0
  this.end = 10
  this.length = data.length

  riot.control.on(riot.EVT.jumpTo, city => {
    const i = data.indexOf(city)
    const [start, end] = [i, i+10]
    const cities = data.slice(start, end)
    this.update({cities, start, end})
  })

  this.reverse = () => {
    this.update({
      cities: this.cities.reverse(),
      reversed: !this.reversed
    })
  }

  this.goTop = () => {
    this._updateSlice(0, 10)
  }

  this.goBottom = () => {
    this._updateSlice(this.length - 10, this.length)
  }

  this.goBack = () => {
    if (this.start > 0) {
      this._updateSlice(this.start - 1, this.end - 1)
    }
  }

  this.goForth = () => {
    if (this.end < data.length) {
      this._updateSlice(this.start + 1, this.end + 1)
    }
  }

  this.info = () => {
    riot.control.trigger(riot.EVT.showLegend)
  }

  this._updateSlice = (start, end) => {
    let cities = data.slice(start, end)
    if (this.reversed) cities = cities.reverse()
    this.update({cities, start, end})
  }

});



// WEBPACK FOOTER //
// ./src/components/measurement-viz.tag